import { render, staticRenderFns } from "./GlobalDialog.vue?vue&type=template&id=f22656c6&scoped=true"
import script from "./GlobalDialog.vue?vue&type=script&lang=js"
export * from "./GlobalDialog.vue?vue&type=script&lang=js"
import style0 from "./GlobalDialog.vue?vue&type=style&index=0&id=f22656c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22656c6",
  null
  
)

export default component.exports